import type { FunctionComponent, ReactElement, SVGAttributes } from 'react';

import styles from './icon.module.css';

export interface IconSvgProps extends SVGAttributes<SVGSVGElement> {
  icon: string;
}

export const IconSvg: FunctionComponent<IconSvgProps> = ({ icon, className = '', ...rest }): ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={`${styles.icon} ${className}`}
    {...rest}
  >
    <use xlinkHref={`#icon-${icon}`} />
  </svg>
);
